const getAuthUrl = () => {
    const hostname = window.location.origin;
    // console.log("getAuthUrl", hostname);
    if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_AUTH_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_AUTH_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_PROD_URI)) {
        return process.env.REACT_APP_PROD_AUTH_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_AUTH_URI;
};

const getApiUrl = () => {
    const hostname = window.location.origin;
    // console.log("getAuthUrl", hostname);
    if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_API_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_API_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_PROD_URI)) {
        return process.env.REACT_APP_PROD_API_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_API_URI;
};

const getRentUrl = () => {
    const hostname = window.location.origin;
    // console.log("getAuthUrl", hostname);
    if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_RENT_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_RENT_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_PROD_URI)) {
        return process.env.REACT_APP_PROD_RENT_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_RENT_URI;
};

const getAppUrl = () => {
    const hostname = window.location.origin;
    // console.log("getAuthUrl", hostname);
    if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_INTERNAL_URI)) {
        return process.env.REACT_APP_DEV_INTERNAL_APP_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_DEV_EXTERNAL_URI)) {
        return process.env.REACT_APP_DEV_EXTERNAL_APP_URI;
    } else if (hostname.includes(process.env.REACT_APP_ADMIN_PROD_URI)) {
        return process.env.REACT_APP_PROD_APP_URI;
    } else return process.env.REACT_APP_DEV_EXTERNAL_APP_URI;
};

const DEFAULT_AUTH_URL = getAuthUrl() + "v1/";
const DEFAULT_API_URL = getApiUrl() + "v1/";
const DEFAULT_RENT_URL = getRentUrl() + "v1/";
const DEFAULT_APP_URL = getAppUrl() + "v1/";

export const LOGIN_URL = DEFAULT_AUTH_URL + "login";
export const SIGNUP_URL = DEFAULT_AUTH_URL + "signup";

export const USER_URL = DEFAULT_AUTH_URL + "user";
export const USERS_URL = DEFAULT_AUTH_URL + "users";
export const USERS_DOWNLOAD_URL = DEFAULT_AUTH_URL + "users.xlsx";
export const USER_STATS_URL = DEFAULT_AUTH_URL + "user/stats";
export const USER_COUNT_URL = DEFAULT_AUTH_URL + "user/count";

export const COUPON_URL = DEFAULT_AUTH_URL + "coupon";
export const COUPONS_URL = DEFAULT_AUTH_URL + "coupons";

export const USER_COUPON_ASSIGN_URL = DEFAULT_AUTH_URL + "user/coupon/assign";

export const DRIVER_LICENSE_ADD_URL = USER_URL + "/driver-license";
export const DRIVER_LICENSE_URL = DRIVER_LICENSE_ADD_URL + "/";
export const IMAGE_URL = "/image";

export const FAQ_URL = DEFAULT_API_URL + "faq";
export const FAQ_LIST_URL = DEFAULT_API_URL + "faqs";

export const CAR_URL = DEFAULT_API_URL + "car";
export const CARS_URL = DEFAULT_API_URL + "cars";
export const EZMOBILITY_CARS_URL = DEFAULT_API_URL + "cars/ezmobility";

export const CAR_MAKER_URL = DEFAULT_API_URL + "car/maker";
export const CAR_MAKER_LIST_URL = DEFAULT_API_URL + "car/makers";

export const CAR_CATEGORY_URL = DEFAULT_API_URL + "car/category";
export const CAR_CATEGORY_LIST_URL = DEFAULT_API_URL + "car/categories";

export const CAR_MODEL_URL = DEFAULT_API_URL + "car/model";
export const CAR_MODEL_LIST_URL = DEFAULT_API_URL + "car/models";

export const CAR_TYPE_URL = DEFAULT_API_URL + "car/type";
export const CAR_TYPE_LIST_URL = DEFAULT_API_URL + "car/types";

export const COLOR_URL = DEFAULT_API_URL + "order/color";
export const COLOR_LIST_URL = DEFAULT_API_URL + "order/colors";

export const OPTION_URL = DEFAULT_API_URL + "order/option";
export const OPTION_LIST_URL = DEFAULT_API_URL + "order/options";

export const MANUAL_URL = DEFAULT_API_URL + "manual";
export const MANUAL_LIST_URL = DEFAULT_API_URL + "manuals";
export const MANUAL_DOWNLOAD_URL = DEFAULT_API_URL + "manual/download";

export const CATALOG_URL = DEFAULT_API_URL + "catalog";
export const CATALOG_LIST_URL = DEFAULT_API_URL + "catalogs";
export const CATALOG_DOWNLOAD_URL = DEFAULT_API_URL + "catalog/download";

export const NOTICE_URL = DEFAULT_API_URL + "notice";
export const NOTICE_LIST_URL = DEFAULT_API_URL + "notices";
export const NOTICE_FILE_DOWNLOAD_URL = DEFAULT_API_URL + "notice/download";

export const SURVEY_URL = DEFAULT_API_URL + "survey/question";
export const SURVEY_LIST_URL = DEFAULT_API_URL + "survey/questions";

export const INFORMATION_TITLE_URL = DEFAULT_API_URL + "information/title";
export const INFORMATION_TITLE_LIST_URL = DEFAULT_API_URL + "information/titles";

export const INFORMATION_SUBTITLE_URL = DEFAULT_API_URL + "information/subtitle";
export const INFORMATION_SUBTITLE_LIST_URL = DEFAULT_API_URL + "information/subtitles";

export const MEDIA_URL = DEFAULT_API_URL + "media";
export const MEDIA_LIST_URL = DEFAULT_API_URL + "medias";

export const ORDER_LIST_URL = DEFAULT_API_URL + "orders";
export const ORDER_MINE_URL = ORDER_LIST_URL + "/mine";
export const ORDER_CANCEL_URL = DEFAULT_API_URL + "order/cancel";
export const ORDER_DELIVERY_STATUS_URL = DEFAULT_API_URL + "order/delivery-status";

export const PAYMENT_CANCEL_URL = DEFAULT_API_URL + "payment/cancel";

export const CAMPINGFAIR_EVENT_USERS_URL = DEFAULT_AUTH_URL + "event/users";
export const CAMPINGFAIR_EVENT_STATS_URL = DEFAULT_AUTH_URL + "event/prize/stats";
export const CAMPINGFAIR_EVENT_PRIZES_URL = DEFAULT_AUTH_URL + "event/prizes";
export const CAMPINGFAIR_EVENT_RECEIVED_PRIZES_URL = DEFAULT_AUTH_URL + "event/user/receive";

export const VISITOR_COUNT_URL = DEFAULT_API_URL + "visitor/count";
export const VISITOR_STATS_URL = DEFAULT_API_URL + "visitor/stats";

export const EVENT_URL = DEFAULT_AUTH_URL + "event/";
export const EVENT_USERS_URL = "/users";
export const EVENT_STATS_URL = "/prize/stats";
export const EVENT_PRIZES_URL = "/prizes";
export const EVENT_RECEIVED_PRIZES_URL = "/user/receive";

export const RENT_CAR_ADD_URL = DEFAULT_RENT_URL + "rent/car";
export const RENT_CAR_URL = RENT_CAR_ADD_URL + "/";
export const RENT_CARS_URL = DEFAULT_RENT_URL + "rent/cars";
export const RENT_CARS_ALL_URL = DEFAULT_RENT_URL + "rent/cars/all";

export const RENT_RESTRICTION_ADD_URL = RENT_CAR_URL + "restriction";
export const RENT_RESTRICTIONS_URL = RENT_CAR_URL + "restrictions";

export const RENT_OPTION_ADD_URL = RENT_CAR_URL + "option";
export const RENT_OPTIONS_URL = RENT_CAR_URL + "options";

export const RENT_ADD_URL = DEFAULT_RENT_URL + "rent";
export const RENT_URL = RENT_ADD_URL + "/";
export const RENTS_URL = DEFAULT_RENT_URL + "rents";
export const RENT_ADD_ADMIN_URL = DEFAULT_RENT_URL + "rent/admin";

export const RENT_CANCEL_URL = "/cancel";
export const RENT_USE_URL = "/start";
export const RENT_RETURN_URL = "/end";
export const RENT_ARRIVE_URL = "/arrive";
export const RENT_START_LIST_URL = RENTS_URL + "/start";
export const RENT_END_LIST_URL = RENTS_URL + "/end";
export const RENT_ALL_URL = RENTS_URL + "/all";

export const RENT_STATS_URL = RENTS_URL + "/stats/";
export const RENT_STATS_OPERATION_URL = RENT_STATS_URL + "operation-days";
export const RENT_STATS_PAID_URL = RENT_STATS_URL + "paid-days";

export const RENT_IMAGE_ADD_START_URL = "/start/images";
export const RENT_IMAGE_ADD_END_URL = "/end/images";
export const RENT_IMAGE_URL = RENT_URL + "image/";

export const RENT_MANUAL_URL = DEFAULT_RENT_URL + "rent/manual";
export const RENT_MANUAL_LIST_URL = DEFAULT_RENT_URL + "rent/manuals";
export const RENT_MANUAL_DOWNLOAD_URL = DEFAULT_RENT_URL + "rent/manual/download";

export const RENT_NOTICE_URL = RENT_URL + "notice";
export const RENT_NOTICE_LIST_URL = RENT_URL + "notices";
export const RENT_NOTICE_FILE_DOWNLOAD_URL = RENT_URL + "notice/download";

export const RENT_VIDEO_MANUAL_URL = DEFAULT_RENT_URL + "rent/manual/video";
export const RENT_VIDEO_MANUAL_LIST_URL = DEFAULT_RENT_URL + "rent/manual/videos";

export const RENT_PAYMENT_ADD_URL = RENT_URL + "payment";
export const RENT_PAYMENT_URL = RENT_PAYMENT_ADD_URL + "/";
export const RENT_PAYMENT_CANCEL_URL = RENT_PAYMENT_URL + "cancel/";
export const RENT_PAYMENT_COMPLETE_URL = RENT_PAYMENT_URL + "complete";
export const RENT_PAYMENT_PREPARE_URL = RENT_PAYMENT_URL + "prepare/";
export const RENT_PAYMENT_ITEMS_URL = RENT_PAYMENT_URL + "items";

export const RENT_PAID_ITEMS_URL = RENT_URL + "paid-items";

export const RENT_PAYMENT_CATEGORIES_URL = RENT_PAYMENT_URL + "categories";

export const RENT_VISITOR_COUNT_URL = RENT_URL + "visitor/count";
export const RENT_VISITOR_STATS_URL = RENT_URL + "visitor/stats";

export const RENT_FAQ_URL = DEFAULT_RENT_URL + "rent/faq";
export const RENT_FAQ_LIST_URL = DEFAULT_RENT_URL + "rent/faqs";

export const RENT_HOLIDAYS_URL = DEFAULT_RENT_URL + "holidays";
export const RENT_ADJUSTMENTS_URL = DEFAULT_RENT_URL + "adjustments";

export const CAR_OWNERS = DEFAULT_APP_URL + "car/owner";
export const DIGITAL_KEY_OWNERS = DEFAULT_APP_URL + "car/owners";
export const OWNER_MINE_URL = DEFAULT_APP_URL + "car/owners/mine";
export const SHARER_MINE_URL = DEFAULT_APP_URL + "car/sharers/mine";
export const CAR_SHARERS_URL = DEFAULT_APP_URL + "car/sharers";
export const DOOR_CAR_URL = DEFAULT_APP_URL + "car/";

export const DOOR_STATUS_URL = DEFAULT_APP_URL + "cars/door/status";

export const BOARD_URL = DEFAULT_AUTH_URL + "board";

export const RENT_REGION_URL = DEFAULT_RENT_URL + "rent/region";
export const RENT_REGION_LIST_URL = DEFAULT_RENT_URL + "rent/regions";

export const RENT_B2B_URL = DEFAULT_RENT_URL + "rent/b2b";
export const RENT_B2B_LIST_URL = DEFAULT_RENT_URL + "rent/b2bs";

export const RENT_PEAK_SEASON_URL = DEFAULT_RENT_URL + "rent/peak-season";
export const RENT_PEAK_SEASON_LIST_URL = DEFAULT_RENT_URL + "rent/peak-seasons";

export const USER_COUPON_URL = DEFAULT_AUTH_URL + "user/coupon/";
export const USER_COUPONS_URL = DEFAULT_AUTH_URL + "user/coupons";
export const MY_COUPON_URL = DEFAULT_AUTH_URL + "user/coupons/mine";
